import { useEffect, useRef } from 'react';

const imageBlocks = [
  {
    id: 'request-charter',
    title: 'Request a Charter',
    image: '/assets/request-charter.jpg',
    route: '/request-charter',
  },
  {
    id: 'empty-legs',
    title: 'See Empty Legs',
    image: '/assets/empty-legs.jpg',
    route: '/empty-legs',
  },
  {
    id: 'locations',
    title: 'Our Locations',
    image: '/assets/locations.jpg',
    route: '/locations',
  },
  {
    id: 'aircraft-guide',
    title: 'Aircraft Guide',
    image: '/assets/aircraft-guide.jpg',
    route: '/aircraft-guide',
  },
];

function HomePage({ navigate, taskbarRef, onNavTextChange }) {
  const heroVideoRef = useRef(null);

  useEffect(() => {
    const updateTaskbarTheme = () => {
      const taskbarHeight = taskbarRef.current ? taskbarRef.current.getBoundingClientRect().height : 0;
      const probeY = window.scrollY + taskbarHeight + 8;
      const contentBlocks = document.querySelectorAll('.home-page > section');
      let activeBlock = null;

      for (const block of contentBlocks) {
        const top = block.offsetTop;
        const bottom = top + block.offsetHeight;

        if (probeY >= top && probeY < bottom) {
          activeBlock = block;
          break;
        }
      }

      if (!activeBlock) {
        onNavTextChange(false);
        return;
      }

      const shouldUseDarkText =
        activeBlock.classList.contains('intro-block') || activeBlock.classList.contains('tbd-block');
      onNavTextChange(shouldUseDarkText);
    };

    const updateTaskbarThemeOnFrame = () => {
      window.requestAnimationFrame(updateTaskbarTheme);
    };

    updateTaskbarThemeOnFrame();
    window.addEventListener('scroll', updateTaskbarTheme, { passive: true });
    window.addEventListener('resize', updateTaskbarThemeOnFrame);

    return () => {
      window.removeEventListener('scroll', updateTaskbarTheme);
      window.removeEventListener('resize', updateTaskbarThemeOnFrame);
      onNavTextChange(false);
    };
  }, [onNavTextChange, taskbarRef]);

  return (
    <div className="home-page">
      <section id="home" className="page-block hero-block">
        <video
          ref={heroVideoRef}
          className="block-media"
          src="/assets/12427495_3840_2160_24fps.mp4"
          autoPlay
          loop
          muted
          playsInline
        />
        <div className="overlay overlay-dark" />
        <div className="hero-content">
          <h1>Travel Southern Africa In Style</h1>
        </div>
      </section>

      <section id="why-aquila" className="page-block intro-block">
        <div className="intro-content">
          <h2>Welcome to Aquila Charters</h2>
          <p>
            <strong>Aquila Charters</strong> is a private aircraft broker company specializing in sourcing empty leg
            flights throughout South Africa and surrounding countries, providing clients with an exceptional opportunity
            to fly privately at a fraction of the usual cost. An empty leg flight occurs when an aircraft is required to
            reposition without passengers, either returning to base or heading to its next charter - making these flights
            available at significantly discounted rates. By connecting clients with these exclusive opportunities, Aquila
            Charters delivers premium private aviation at outstanding value. In addition, we offer on-demand private
            charter services, arranging tailored flights to meet your exact schedule, destination, and aircraft
            requirements, ensuring seamless, flexible, and efficient private travel.
          </p>
        </div>
      </section>

      {imageBlocks.map((block) => (
        <section key={block.id} id={block.id} className="page-block image-block">
          <img className="block-media" src={block.image} alt={block.title} />
          <div className="overlay overlay-light" />
          <button className="pill-button" type="button" onClick={() => navigate(block.route)}>
            {block.title}
          </button>
        </section>
      ))}

      <section className="page-block newsletter-block">
        <img className="block-media" src="/assets/newsletter-bg.jpg" alt="" />
        <div className="overlay overlay-newsletter" />
        <div className="newsletter-content">
          <h2>Subscribe to Our Newsletter</h2>
          <p>Subscribe for exclusive updates and be the first to know when an empty leg becomes available</p>
          <div className="email-placeholder">Enter Email Address</div>
        </div>
      </section>
    </div>
  );
}

export default HomePage;
